import React from 'react';
import { NavLink } from 'react-router-dom';

const AddPrecedentCrumb = () => <NavLink to="/core/precedents/add">Add Precedent</NavLink>;

export default AddPrecedentCrumb;
